(function () {
  function shortName(name) {
    if (!name) return "Anonymous";
    var parts = String(name).trim().split(/\s+/);
    if (parts.length === 1) return parts[0];
    return parts[0] + " " + parts[parts.length - 1].charAt(0);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function timeAgo(isoDate) {
    if (!isoDate) return "";
    var date = new Date(isoDate);
    if (Number.isNaN(date.getTime())) return "";
    var seconds = Math.floor((Date.now() - date.getTime()) / 1000);
    if (seconds < 60) return "just now";
    var minutes = Math.floor(seconds / 60);
    if (minutes < 60) return minutes + " min ago";
    var hours = Math.floor(minutes / 60);
    if (hours < 24) return hours + " hours ago";
    var days = Math.floor(hours / 24);
    if (days < 30) return days + " days ago";
    var months = Math.floor(days / 30);
    if (months < 12) return months + " months ago";
    var years = Math.floor(months / 12);
    return years + " years ago";
  }

  function buildStars(rating) {
    var rounded = Math.round(Number(rating) || 0);
    var html = "";
    for (var i = 1; i <= 5; i += 1) {
      html += i <= rounded ? "★" : "☆";
    }
    return html;
  }

  function render(sectionEl, payload) {
    var reviews = payload.reviews || [];
    var limit = Number(sectionEl.dataset.limit || 8);
    var titleFallback = sectionEl.dataset.productTitleFallback || "Product Review";
    var items = reviews.slice(0, limit);
    var track = sectionEl.querySelector("[data-static-reviews-track]");
    var summaryEl = sectionEl.querySelector("[data-static-reviews-summary]");
    var emptyEl = sectionEl.querySelector("[data-static-reviews-empty]");

    if (!items.length) {
      track.innerHTML = "";
      summaryEl.innerHTML = "";
      emptyEl.hidden = false;
      return;
    }

    emptyEl.hidden = true;

    var avg = Number(payload.avg || 0);
    var count = Number(payload.count || items.length);
    summaryEl.innerHTML =
      '<span class="static-reviews__stars" aria-hidden="true">' +
      buildStars(avg) +
      '</span><span class="static-reviews__summary-text">' +
      '<span class="static-reviews__summary-emphasis">' +
      avg.toFixed(1) +
      "</span>" +
      " based on " +
      '<span class="static-reviews__summary-emphasis">' +
      count +
      "</span>" +
      " reviews</span>";

    track.innerHTML = items
      .map(function (review) {
        var productName =
          (review.product && review.product.name) ||
          review.product_name ||
          titleFallback;
        var metaParts = [];
        if (review.location) metaParts.push(escapeHtml(review.location));
        if (review.created_at) metaParts.push(timeAgo(review.created_at));

        return (
          '<article class="static-reviews__card">' +
          '<header class="static-reviews__card-header">' +
          '<div class="static-reviews__author-row">' +
          '<h3 class="static-reviews__author">' +
          escapeHtml(shortName(review.author)) +
          "</h3>" +
          '<span class="static-reviews__stars" aria-label="' +
          escapeHtml(String(review.rating || 0)) +
          ' stars">' +
          buildStars(review.rating) +
          "</span>" +
          "</div>" +
          '<p class="static-reviews__product">' +
          escapeHtml(productName) +
          "</p>" +
          "</header>" +
          '<p class="static-reviews__body">' +
          escapeHtml(review.body || review.comments || "") +
          "</p>" +
          '<p class="static-reviews__meta">' +
          escapeHtml(metaParts.join(", ")) +
          "</p>" +
          "</article>"
        );
      })
      .join("");
  }

  async function hydrate(sectionEl) {
    var sourceUrl = sectionEl.dataset.sourceUrl;
    var sourceType = sectionEl.dataset.sourceType;
    var productHandle = sectionEl.dataset.productHandle;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var candidates = [];

    if (sourceUrl) candidates.push(sourceUrl);
    if (sourceType === "product" && productHandle) {
      candidates.push(root + "assets/reviews-product.json");
    }
    if (sourceType === "store" || !candidates.length) {
      candidates.push(root + "assets/reviews-store.json");
    }
    candidates = Array.from(new Set(candidates));

    try {
      var reviews = null;
      var lastError = null;

      for (var i = 0; i < candidates.length; i += 1) {
        var candidateUrl = candidates[i];
        try {
          var res = await fetch(candidateUrl, { credentials: "same-origin" });
          if (!res.ok) throw new Error("HTTP " + res.status);
          var text = await res.text();
          var payload = JSON.parse(text);
          if (!Array.isArray(payload)) throw new Error("Payload is not array");
          reviews = payload;
          break;
        } catch (candidateError) {
          lastError = candidateError;
        }
      }

      if (!reviews) {
        throw lastError || new Error("Unable to load any review payload");
      }

      if (sourceType === "product" && productHandle) {
        reviews = reviews.filter(function (review) {
          return review && review.product && review.product.handle === productHandle;
        });
      }

      var total = reviews.length;
      var avg =
        total > 0
          ? reviews.reduce(function (acc, item) {
              return acc + (Number(item.rating) || 0);
            }, 0) / total
          : 0;
      render(sectionEl, { reviews: reviews, count: total, avg: avg });
    } catch (error) {
      render(sectionEl, { reviews: [] });
      sectionEl.setAttribute("data-static-reviews-error", "true");
      if (window.console && window.console.warn) {
        window.console.warn("Static reviews failed to load:", candidates, error);
      }
    }
  }

  function setupNav(sectionEl) {
    var track = sectionEl.querySelector("[data-static-reviews-track]");
    var prev = sectionEl.querySelector("[data-static-reviews-prev]");
    var next = sectionEl.querySelector("[data-static-reviews-next]");
    if (!track || !prev || !next) return;

    prev.addEventListener("click", function () {
      track.scrollBy({ left: -track.clientWidth * 0.85, behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      track.scrollBy({ left: track.clientWidth * 0.85, behavior: "smooth" });
    });
  }

  function init() {
    var sections = document.querySelectorAll("[data-static-reviews]");
    sections.forEach(function (sectionEl) {
      setupNav(sectionEl);
      hydrate(sectionEl);
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
